<template>
  <div class="h-full">
    <!-- 三维视频画面 -->
    <div class="h-full w-full">
      <div class="w-full h-[calc(100%-30px)]">
        <el-table
          :data="tableData"
          height="100%"
          class="transition-none"
          @row-click="handleRowClick"
          highlight-current-row
        >
          <el-table-column label="" width="20">
            <template>
              <div class="selected-row"></div>
            </template>
          </el-table-column>
          <el-table-column label="摄像头名称" prop="name" show-overflow-tooltip></el-table-column>
          <el-table-column label="所属区域" prop="areaName" show-overflow-tooltip></el-table-column>
          <el-table-column label="操作" align="center" width="80">
            <template slot-scope="scope">
              <span
                class="text-blue-500 bold hover:text-blue-200 cursor-pointer"
                @click="play(scope.row)"
                >播放</span
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="text-center">
        <el-pagination
          @current-change="handlePageChange"
          :current-page="currentPage"
          background
          :page-size="pageSize"
          layout="total, prev, pager, next"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 摄像头弹窗 -->
    <videoDialog
      v-if="videoDialogShow"
      :show.sync="videoDialogShow"
      :code="cameraCode"
      :name="cameraName"
      :pIid="pIid"
      :showControlPanel="true"
      :manufacturerCode="manufacturerCode"
      :isHistory="true"
    ></videoDialog>
  </div>
</template>

<script>
import videoDialog from './components/video/videoDialog'

export default {
  name: 'EmergencyResponseDetailRight',
  props: {
    transferProps: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  components: {
    videoDialog,
  },
  data() {
    return {
      tableData: [],
      pageSize: 10,
      currentPage: 1,
      total: 0,
      videoDialogShow: false,
      manufacturerCode: 'Hik', // 厂商
      pIid: '', // 宇视才需要这个pIid
      cameraCode: '',
      cameraName: '',
      daHuaParams: {},
    }
  },
  created() {
    this.searchListCamera()
  },
  methods: {
    /**
     * unknown what related to fence and alarm
     * @description 列表查询(摄像头列)
     */
    async searchListCamera() {
      // 列表数据（摄像头列）
      const params = {
        PageNumber: this.currentPage,
        PageSize: this.pageSize,
        FenceId: this.transferProps.row.standardFenceId || '',
      }
      this.searchData.keyword && (params.Name = this.searchData.keyword)
      this.searchData.fenceType && (params.Type = this.searchData.fenceType)
      this.searchData.openStatus.length > 0 && (params.Status = this.searchData.openStatus)
      const res = await axios({
        method: 'post',
        url: `${ApiBase}/api/ApiEngine/Run`,
        data: {
          ApiEngineKey: 'PositionFenceRelationCameraList',
          ...params,
        },
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('authorization')}`,
        },
      })
      if (res.data && res.data.Code === 1 && res.data.Data) {
        let cameraList = []
        try {
          cameraList = JSON.parse(res.data.Data[0].CameraList)
        } catch (error) {
          console.log(error)
        }
        if (Array.isArray(cameraList)) {
          this.tableData = cameraList
          this.total = cameraList.length
        }
      }
    },

    handlePageChange(newPage) {
      this.currentPage = newPage
    },
    handleRowClick(row) {
    },
    async play(row) {
      this.pIid = row.pIid
      this.cameraCode = row.code || ''
      this.cameraName = row.name || ''
      this.manufacturerCode = row.manufacturerCode || 'Hik'
      this.daHuaParams = {
        id: row.id,
        code: row.code,
      }
      this.videoDialogShow = true
      const str = sessionStorage.getItem('cameraMarkList')
      if (str && JSON.parse(str).length) {
        const markList = JSON.parse(str)
        const index = _.findIndex(markList, ['id', row.id])
        if (index > -1) {
          const treeData = await this.player.Native.ModelTree.getRootItems()
          this.player?.Native.Camera.moveToPos(
            JSON.parse(markList[index].threeDPosition),
            treeData[0]?.nodePtr,
            50,
            2
          )
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped></style>
